module.exports = __webpack_public_path__ + "media/components/country-flag/static/sg-061070f5a575f0204baa242b07571b09.svg";